import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';

const CTASection = () => {
  const handleSignInClick = () => {
    window.location.href = '/login';
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 10, md: 14 },
        background: `
          radial-gradient(1200px 400px at 50% -100px, rgba(16,185,129,0.18), transparent 60%),
          linear-gradient(180deg, #ECFDF5 0%, #F0FDF9 100%)
        `,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {/* Heading */}
          <Typography
            sx={{
              fontSize: { xs: '2.1rem', md: '2.9rem' },
              fontWeight: 800,
              color: '#0F172A',
              mb: 2.5,
              lineHeight: 1.2,
              letterSpacing: '-0.02em',
            }}
          >
            Ready to Transform Your Talent Discovery?
          </Typography>

          {/* Subheading */}
          <Typography
            sx={{
              fontSize: '1.15rem',
              color: '#475569',
              maxWidth: 640,
              mb: 5,
              lineHeight: 1.65,
            }}
          >
            Join thousands of forward-thinking organizations finding top talent faster.
          </Typography>

          {/* SignIn Button */}
          <Button
            onClick={handleSignInClick}
            variant="contained"
            disableElevation
            sx={{
              px: 5.5,
              py: 1.9,
              fontSize: '1.05rem',
              fontWeight: 700,
              textTransform: 'none',
              borderRadius: 2.5,
              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              boxShadow: '0 12px 30px rgba(16,185,129,0.35)',
              transition: 'all 0.25s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 18px 40px rgba(16,185,129,0.45)',
                background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
              },
              '&:active': {
                transform: 'translateY(0)',
                boxShadow: '0 10px 25px rgba(16,185,129,0.3)',
              },
            }}
          >
            Sign In
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection;